import { createContext, useContext } from 'react';
import type { RefObject } from 'react';

interface PopOverContextValue {
  open: boolean;
  contentId: string;
  toggle: () => void;
  close: () => void;
  triggerRef: RefObject<HTMLElement | null>;
  contentRef: RefObject<HTMLDivElement | null>;
  /** anchorEl prop으로 전달된 위치 기준 엘리먼트 — Content 위치 계산에 triggerRef보다 우선 */
  anchorEl: HTMLElement | null;
}

const PopOverContext = createContext<PopOverContextValue | null>(null);

export const usePopOverContext = (): PopOverContextValue => {
  const ctx = useContext(PopOverContext);
  if (!ctx) throw new Error('[PopOver] PopOver.Trigger/Content는 PopOver 내부에서만 사용할 수 있습니다.');
  return ctx;
};

export const PopOverProvider = PopOverContext.Provider;
